/* @flow */
import React, { PropTypes } from 'react';
import {connect} from 'react-redux';
import LocalePicker from './locale-picker/locale-picker';
import CountryPicker from './country-picker/country-picker';
import RightSection from './right-section/right-section';
import { Authenticated } from 'interactive-solutions/authentication';
import { Link } from 'react-router';
import * as variables from 'frilans-finans/variables';
import Utils from 'frilans-finans/utils/utils';

export class Header extends React.Component {

  static propTypes = {
    auth: PropTypes.object,
    user: PropTypes.object,
    selectedLocale: PropTypes.string.isRequired,
    selectedCountry: PropTypes.string.isRequired,
    availableLocales: PropTypes.array.isRequired,
    availableCountries: PropTypes.array.isRequired
  };

  static contextTypes = {
    user: React.PropTypes.object
  };

  render () {
    return (
      <header className='page-header sticky'>
        <div className='container'>

          <a href={variables.frontUrl} className='logo'>
            <object type="image/svg+xml"
              data={require('images/logos/logo-white.svg')}
              alt='Frilans Finans-logotyp'>
              <img src={require('images/logos/logo-white.png')} alt="Frilans Finans-logotyp"/>
            </object>
          </a>

          <RightSection user={this.props.user}/>
          <div className='left-section hide-large-tablet'>
            <div className='left-menus'>

              <CountryPicker countries={this.props.availableCountries} selectedCountry={this.props.selectedCountry}/>
              <LocalePicker locales={this.props.availableLocales} selectedLocale={this.props.selectedLocale}/>

            </div>

            <Authenticated>
              <p className='username hide-large-tablet'>{this.props.user.firstName} {this.props.user.lastName}</p>
              <Link to='economy/loyalty-program/points' className='loyalty-points'>
                {Utils.numberWithSpaces(Utils.floor(this.props.user.loyaltyPoints))} p
              </Link>
            </Authenticated>
          </div>

        </div>
      </header>
    );
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    user: state.user,

    selectedLocale: state.i18n.locale,
    selectedCountry: state.i18n.country,
    availableLocales: state.i18n.availableLocales,
    availableCountries: state.i18n.availableCountries
  };
};

export default connect(mapStateToProps)(Header);



/** WEBPACK FOOTER **
 ** ./src/components/header/header.js
 **/